<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="text-right">
          <button @click="() => getRecords()" class="btn btn-outline-success">Обновить</button>
        </div>

        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
        <template v-if="!loading && records && records.length">
          <table class="table table-hover table-sm mt-1">
            <thead>
            <tr>
              <th></th>
              <th width="310px">Телефон / Заявка / ЧС</th>
              <th>Звонки</th>
              <th>Страница</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in records">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>
                <div v-for="p in r.data.phones" class="flex">
                  <div class="mr-1 flex">
                    <MakeFreeCall :callData="{siteId: 1, cityId:1}" :phone="{phone: p, valid: true}">
                      <slot>
                        <span class="phone_span"><i class="icon-fa icon-fa-phone"/></span>
                      </slot>
                    </MakeFreeCall>
                    <span>{{ p }}</span>
                  </div>
                  <span v-if="ordersRecords[p]" class="mr-1">
                    <span class="phone_span"
                          @click="openOrderInModal(ordersRecords[p])"
                    >
                    <i class="icon-fa icon-fa-eye"></i>
                    </span>
                    {{ ordersRecords[p] }}
                  </span>
                  <span class="badge badge-danger" v-if="blackList[p]">
                    BLACK LIST
                    <!--                    {{ blackList[p] }}-->
                  </span>
                </div>
              </td>
              <td>
                <div v-for="p in r.data.phones" v-html="getPhoneCalls(p)"/>
              </td>
              <td>
                <p><a :href="r.page" target="_blank">{{ r.page }}</a></p>
                <p>{{ r.data.ip }}</p>
              </td>
              <td></td>
              <td>{{ printDate(r.created_at) }}</td>
              <td>
                <LoadingButton
                  title="скрыть"
                  type="button"
                  :loading="loadingBtns[r.id]"
                  :color="$constants.WARNING_COLOR"
                  :onClick="() => {updateRecord(i, 'deactivate')}"
                  className="btn btn-outline-danger btn-xs"
                />
              </td>
            </tr>
            </tbody>
          </table>
        </template>
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from "vuejs-paginate";
import MakeFreeCall from "@/components/orders/telephony/MakeFreeCall";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    Paginate,
    MakeFreeCall,
    LoadingButton,
  },
  data() {
    return {
      records: [],
      ordersRecords: {},
      loading: false,
      paginator: null,
      loadingBtns: {},
      blackList: {},
      phoneCalls: [],
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    getPhoneCalls(phone) {
      const record = this.phoneCalls.filter((c) => c.phone_title + '' === phone || c.destination + '' === phone);
      if (record.length) {
        let html = '';
        record.forEach((c) => {
          html += '<p>звонок ' + this.printDate(c.created_at) + '</p>';
        })
        return html;
      }
      return '';
    },
    async updateRecord(index, type) {
      this.loadingBtns[this.records[index].id] = true;
      this.loadingBtns = {...this.loadingBtns};
      const {data} = await api.post('/clients/updateCold', {
        id: this.records[index].id,
        action: type
      })
      if (data.success) {
        this.loadingBtns[this.records[index].id] = false;
        delete this.records[index];
        this.records = this.records.filter((r) => r);
        return;
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.loadingBtns[this.records[index].id] = false;
    },
    openOrderInModal(orderId) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: orderId, callBackAction: 'refreshList'})
    },
    async getRecords(page = 1) {
      this.loading = true;
      const {data: r_data} = await api.index('/clients/cold?page=' + page);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.blackList = r_data.blackList.reduce((acc, b) => {
          acc[b.phone_num.substring(2)] = b;
          return acc;
        }, {})
        this.ordersRecords = r_data.ordersRecords;
        this.phoneCalls = r_data.phoneCalls;
        this.records = data;
        this.paginator = pagination;
      } else {
        toastr['warning'](r_data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.phone_span {
  background-color: #5bbfde;
  color: white;
  padding: 1px 5px;
  margin-right: 3px;
  cursor: pointer;
  border-radius: 20%;
}

</style>
